import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { ROUTES } from '@/constants/routes'
import { IdleLockGate } from '@/modules/auth/lock/IdleLockGate'
import { StepUpDialog } from '@/modules/auth/lock/StepUpDialog'

export function ProtectedRoute() {
  const { isAuthenticated, isHydrated, user } = useAuth()
  const location = useLocation()

  if (!isHydrated) return null

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />
  }

  // New user / admin reset: nothing else opens until they choose a password.
  if (user?.mustChangePassword && location.pathname !== ROUTES.CHANGE_PASSWORD) {
    return <Navigate to={ROUTES.CHANGE_PASSWORD} replace />
  }

  // Role requires a PIN that is not set yet.
  if (!user?.mustChangePassword && user?.security?.pinSetupRequired && location.pathname !== ROUTES.PIN_SETUP) {
    return <Navigate to={ROUTES.PIN_SETUP} replace />
  }

  return (
    <>
      <Outlet />
      <IdleLockGate />
      <StepUpDialog />
    </>
  )
}
